import { Table, styled, tableCellClasses } from '@/core/ui';
import { shouldNotForwardProps } from '@/shared/helpers';
export const GroupedListItemTableStyled = styled(Table, shouldNotForwardProps('cellPaddingInline'))(({ theme, cellPaddingInline }) => ({
    paddingBottom: theme.spacing(4),
    ...(cellPaddingInline === 'small' && {
        [`.${tableCellClasses.root}`]: {
            paddingInline: '.5rem',
        },
    }),
}));
